import api from './api';

export interface OperationLogListRequest {
  page?: number;
  size?: number;
  username?: string;
  action?: string;
  resource?: string;
  request_id?: string;
  method?: string;
  path?: string;
  success?: boolean | null;
  start_time?: string;
  end_time?: string;
}

export interface OperationLogItem {
  id: number;
  request_id: string;
  user_id?: number;
  username: string;
  user_type: string;
  client_id?: number;
  action: string;
  resource: string;
  path: string;
  method: string;
  success: boolean;
  status_code: number;
  message?: string;
  request_body?: string;
  response_body?: string;
  ip_address?: string;
  user_agent?: string;
  execution_time: number;
  created_at: string;
}

export interface OperationLogListResponse {
  list: OperationLogItem[];
  total: number;
  page: number;
  size: number;
}

export const operationLogService = {
  async list(params: OperationLogListRequest = {}): Promise<OperationLogListResponse> {
    const response = await api.post('/api/logs/operations', params);
    return response.data.data;
  },
};


